import React, { useState, useEffect } from 'react';
import {
  EmailIcon,
  DiscordIcon,
  BookMeetingIcon,
  QuestionIcon
} from '@/components/common/icon';
import { useTranslation } from 'react-i18next';

interface Props {}

const ContactUs: React.FC<Props> = ({}) => {
  const { t } = useTranslation();

  const handleDisCord = () => {
    window.open(
      'https://discord.com/invite/EtcfjsFWq4?aha_source=webflow&AHA_ORDER_ID=67742f07e0534eed7af2c368&AHA_CAMPAIGN_ID=184',
      '_blank'
    );
  };

  const handleEmail = () => {
    window.location.href = 'mailto:support@creator.aha.inc';
  };

  const handleMeeting = () => {
    window.open(
      'https://calendly.com/contact-ahaads/aha-creator-feedback',
      '_blank'
    );
  };

  return (
    <div className="fixed right-[24px] bottom-[24px] z-[999] group/main pt-[12px]">
      <div className="w-[32px] h-[32px] rounded-[32px] flex justify-center items-center bg-[#171717] shadow-custom">
        <QuestionIcon className="text-white" />
      </div>
      <div className="absolute right-0 bottom-[44px] bg-white w-[245px] py-3 px-4 rounded-[8px] shadow-custom flex-col gap-4 hidden  group-hover/main:flex">
        {/* <div
          className="flex items-center gap-3 cursor-pointer hover: group"
          onClick={handleDisCord}
        >
          <DiscordIcon className="group-hover:text-[#5A31F0]" />
          <div className="flex flex-col gap-1">
            <div className="justify-center text-stone-900 text-base font-bold font-['Plus_Jakarta_Sans'] leading-tight tracking-tight group-hover:text-[#5A31F0]">
              Discord
            </div>
            <div className="opacity-60 justify-center text-stone-800 text-base font-medium font-['Plus_Jakarta_Sans'] leading-none tracking-tight group-hover:text-[#5a31f0]/50">
              Join immediately
            </div>
          </div>
        </div> */}
        <div
          className="flex items-center gap-3 cursor-pointer hover: group"
          onClick={handleEmail}
        >
          <EmailIcon className="group-hover:text-[#5A31F0]" />
          <div className="flex flex-col gap-1">
            <div className="justify-center text-stone-900 text-base font-bold font-['Plus_Jakarta_Sans'] leading-tight tracking-tight group-hover:text-[#5A31F0]">
              {t('components.contactUs.email.title', {
                defaultValue: 'Email'
              })}
            </div>
            <div className="opacity-60 justify-center text-stone-800 text-base font-medium font-['Plus_Jakarta_Sans'] leading-none tracking-tight group-hover:text-[#5a31f0]/50">
              {t('components.contactUs.email.description', {
                defaultValue: 'Contact support'
              })}
            </div>
          </div>
        </div>
        {/* <div
          className="flex items-center gap-3 cursor-pointer hover: group"
          onClick={handleMeeting}
        >
          <BookMeetingIcon className="group-hover:text-[#5A31F0]" />
          <div className="flex flex-col gap-1">
            <div className="justify-center text-stone-900 text-base font-bold font-['Plus_Jakarta_Sans'] leading-tight tracking-tight group-hover:text-[#5A31F0]">
              Book a meeting
            </div>
            <div className="opacity-60 justify-center text-stone-800 text-base font-medium font-['Plus_Jakarta_Sans'] leading-none tracking-tight group-hover:text-[#5a31f0]/50">
              Contact human expert
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ContactUs;
